module.exports = __webpack_public_path__ + "img/manchester-united.aaa70615.png";